// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./Login.css"; // Import the CSS file
// // import "../../../src/App.css";
// import { IoMdClose, IoMdCloseCircle } from "react-icons/io";
// import {
//   FaMobileAlt,
//   FaCaretDown,
//   FaUser,
//   FaEye,
//   FaEyeSlash,
// } from "react-icons/fa"; // Import icons
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";
// import apiBaseUrl from "../../config/config";
// import { useAuth } from "../AuthContext";
// import CaptchaBox from "../CaptchaBox/CaptchaBoc";

// const Login = (props) => {
//   const navigate = useNavigate();
//   const { login } = useAuth();

//   const [formData, setFormData] = useState({
//     user_name: "",
//     password: "",
//     site_code: apiBaseUrl.sitecodes,
//     user_type: "User",
//   });

//   const [showPopup, setShowPopup] = useState(false);
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [dropdownOpen, setDropdownOpen] = useState(false); // State for toggling dropdown
//   const [inputType, setInputType] = useState("mobile"); // State for controlling which input type is selected
//   const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
//   const [isDisabled, setIsDisabled] = useState(false);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   const handleSubmit = (event) => {
//     event.preventDefault();

//     var config = {
//       method: "post",
//       url: `${apiBaseUrl.apiUrl}users/userAuthenticate`,
//       headers: {
//         "Content-Type": "application/json",
//       },

//       data: JSON.stringify(formData),
//     };
//     axios(config)
//       .then(function (response) {
//         if (response.data.result) {
//           toast.success(response.data.resultMessage, { autoClose: 500 });
//           // localStorage.setItem(
//           //   "userdata",
//           //   JSON.stringify(response.data.resultData)
//           // );
//           login(response.data.resultData);

//           // setTimeout(() => {
//           //   props?.togglePopup();
//           //   props?.handleClose();
//           // }, 1000);
//           if (props?.togglePopup) {
//             props.togglePopup();
//           }
//           if (props?.handleClose) {
//             props.handleClose();
//           }
//         } else {
//           toast.error("Invalid Credentials", { autoClose: 800 });
//         }
//         formData.user_name = "";
//         formData.password = "";
//       })
//       .catch(function (error) {
//         console.log(error);
//         toast.error("An error occurred during login", { autoClose: 800 });
//       });
//   };

//   const toggleDropdown = () => {
//     setDropdownOpen(!dropdownOpen);
//   };

//   const handleInputTypeChange = (type) => {
//     setInputType(type);
//     setDropdownOpen(false); // Close dropdown after selection
//     setUsername(""); // Reset username field when switching input types
//   };

//   // const handleLogin = (e) => {
//   //   e.preventDefault();

//   //   // Hardcoded credentials for testing
//   //   const hardcodedUsername = 'user';
//   //   const hardcodedPassword = '1234';

//   //   // Check the credentials
//   //   if (username === hardcodedUsername && password === hardcodedPassword) {
//   //     // Store login status in localStorage
//   //     localStorage.setItem('isAuthenticated', 'true');
//   //     setError(''); // Clear any previous errors

//   //     // Navigate to the main page after successful login
//   //     navigate('/');  // Redirect to home page (or whichever route you prefer)
//   //   } else {
//   //     setError('Invalid username or password');  // Display an error message
//   //   }
//   // };

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword); // Toggle between showing and hiding password
//   };

//   const handleCreateAccount = () => {
//     navigate("/signup"); // Navigate to the signup page
//   };

//   const loginDemoID = async () => {
//     setIsDisabled(true);
//     // setIsLoading(true)

//     var demoData = {
//       user_name: "demo_user",
//       password: "123456",
//       site_code: apiBaseUrl.sitecodes,
//       user_type: "User",
//     };

//     var config = {
//       method: "post",
//       url: `${apiBaseUrl.apiUrl}users/userAuthenticate`,
//       headers: {
//         "Content-Type": "application/json",
//       },

//       data: JSON.stringify(demoData),
//     };
//     axios(config)
//       .then(function (response) {
//         setIsDisabled(false);

//         if (response.data.result != 0) {
//           toast.success(response.data.resultMessage, { autoClose: 500 });

//           // setIsLoading(false)
//           login(response.data.resultData);

//           // setTimeout(() => {
//           //   props?.togglePopup();
//           //   props?.handleClose();
//           // }, 1000);
//           if (props?.togglePopup) {
//             props.togglePopup();
//           }
//           if (props?.handleClose) {
//             props.handleClose();
//           }
//           // storeUserinfo(response.data.resultData);
//         } else {
//           // console.log('--', response.data.resultMessage)
//           // errorNotification();
//           toast.success(response.data.resultMessage, { autoClose: 800 });
//         }
//       })
//       .catch(function (error) {
//         setIsDisabled(false);
//         console.log(error);
//       });
//   };

//   const [captchaQuestion, setCaptchaQuestion] = useState("");

//   const generateCaptcha = () => {
//     const num1 = Math.floor(Math.random() * 50) + 1;
//     const num2 = Math.floor(Math.random() * 50) + 1;
//     setCaptchaQuestion(`${num1} + ${num2} = ?`);
//   };

//   useState(() => {
//     generateCaptcha();
//   }, []);

//   return (
//     <>
//       {/* Login Button */}
//       {/* <button className="pushable-login submit-btn login-trigger " onClick={togglePopup}>
//         <span className="front-login">Login</span>
//       </button> */}

//       {/* Popup */}
//       {props?.showPopup && (
//         <div
//           className="login-popup-overlay fixed inset-0 bg-black/50 backdrop-blur-md flex items-center justify-center z-5"
//           onClick={() => props?.togglePopup()}
//         >
//           <div
//             className="w-[352px] h-[366px]  login-popup-content"
//             onClick={(e) => e.stopPropagation()}
//           >
//             {/* <span className="close-btn">
//               <IoMdClose onClick={() => props?.togglePopup()} />
//             </span> */}
//             <span
//               className="absolute top-2 right-2 p-1 text-black hover:text-gray-800 cursor-pointer transition-colors"
//               onClick={() => props?.togglePopup()}
//             >
//               <IoMdClose className="w-5 h-5" />
//             </span>
//             <div className="login-popup-logo">
//            <h5 className="text-black text-center font-bold text-[20px] mt-2">
//               Login</h5>
//             </div>
//             <form className="login-form text-[#000]" onSubmit={handleSubmit}>
//               {/* Dynamic label */}
//               <label className="text-black text-sm mb-1">
//                 {inputType === "mobile" ? "Mobile Number" : "User ID"}
//               </label>

//               {/* Username Section with Dropdown */}
//               <div className="username">
//                 <span className="input-label">
//                   {inputType === "mobile" ? "+91" : "ID"}
//                 </span>
//                 <input
//                   className="login-input"
//                   type="text"
//                   name="user_name"
//                   placeholder={
//                     inputType === "mobile"
//                       ? "Enter mobile number"
//                       : "Enter user ID"
//                   }
//                   required
//                   value={formData.user_name}
//                   onChange={(e) => handleInputChange(e)}
//                 />
//                 <span className="icon relative pr-2" onClick={toggleDropdown}>
//                   <FaMobileAlt
//                     size={30}
//                     color="#e9b02e"
//                     style={{ marginRight: 0 }}
//                     className="absolute top-[-0.3rem] right-[0.5rem]"
//                   />{" "}
//                   <FaCaretDown
//                     size={20}
//                     color="#e9b02e"
//                     style={{ marginRight: 0 }}
//                     className="absolute top-[0.1rem]"
//                   />
//                 </span>{" "}
//                 {/* Mobile icon */}
//                 {/* Dropdown Menu */}
//                 {dropdownOpen && (
//                   <div className="dropdown-menu show">
//                     <div onClick={() => handleInputTypeChange("mobile")}>
//                       <FaMobileAlt
//                         size={20}
//                         color="#e9b02e"
//                         style={{ width: "100%", padding: "14px", marginTop:"0px", borderRadius:"8px", height:"35px" }}
//                       />
//                       Mobile Number
//                     </div>
//                     <div onClick={() => handleInputTypeChange("userid")}>
//                       <FaUser
//                         size={20}
//                         color="#e9b02e"
//                        style={{ width: "100%", padding: "14px", marginTop:"0px", borderRadius:"8px", height:"35px" }}
//                       />
//                       User ID
//                     </div>
//                   </div>
//                 )}
//               </div>

//               <span className="text-black ">Password</span>
//               <div className="password">
//                 <input
//                   className="password-input"
//                   type={showPassword ? "text" : "password"} // Toggle between 'text' and 'password'
//                   name="password"
//                   placeholder="Password"
//                   required
//                   value={formData.password}
//                   onChange={(e) => handleInputChange(e)}
//                   style={{ width: "100%", padding: "14px", marginTop:"0px", borderRadius:"8px", height:"35px" }}
//                 />
//                 <span
//                   className="password-toggle"
//                   onClick={togglePasswordVisibility}
//                 >
//                   {showPassword ? (
//                     <FaEyeSlash size={20} />
//                   ) : (
//                     <FaEye size={20} />
//                   )}
//                 </span>{" "}
//                 {/* Eye icon to toggle password visibility */}
//               </div>

//                <div className=" w-80  rounded-md shadow">
//                 {/* other form inputs */}
//                 <CaptchaBox onRefresh={generateCaptcha} captchaQuestion={captchaQuestion} />
//               </div>

//               <button type="submit"  className="w-full flex items-center justify-center text-[16px] rounded-[3px] h-[40px] px-[10px] pt-[3px] pb-[5px] border border-[#065265] bg-gradient-to-b from-[#6fe3f5] to-[#065265] text-white shadow-sm transition-all duration-200"
//               style={{ textShadow: "0 1px 1px rgba(0,0,0,0.5)", marginTop: 10 }}>
//                 <span className="front">Login</span>
//               </button>
//               <button
//                 type="button"
//                 onClick={() => loginDemoID()}
//                 className="w-full flex items-center justify-center text-[16px] rounded-[3px] h-[40px] px-[10px] pt-[3px] pb-[5px] border border-[#065265] bg-gradient-to-b from-[#6fe3f5] to-[#065265] text-white shadow-sm transition-all duration-200"
//                style={{ textShadow: "0 1px 1px rgba(0,0,0,0.5)", marginTop: 10 }}
//                 disabled={isDisabled}
//               >
//                 <span className="front">Login With Demo</span>
//               </button>
//             </form>
//             {/* {error && <p className="error">{error}</p>}
//             <span
//               className=""
//               style={{
//                 color: "#fff",
//                 display: "block",
//                 textAlign: "right",
//                 marginTop: "10px",
//               }}
//               onClick={() => props.toggleForgotPopup()}
//             >
//               Forgot Password
//             </span> */}
//             {/* <span className="other-login">Or login with</span> */}
//             <span className="other-button">
//               {/* <button className="google border border-gray-500">
//                 <div className="flex justify-center items-center">
//                   <img
//                     src="./Images/google.png"
//                     alt=""
//                     className="google-image"
//                   />
//                   <span className="text-[#fff]">Google</span>
//                 </div>
//               </button> */}
//               {/* <button
//                 className="whatsapp"
//                 onClick={() => props?.openWhatsApp(props?.whatsappNum)}
//               >
//                 <div className="flex justify-center items-center">
//                   <img
//                     src="./Images/whatsapp.png"
//                     alt=""
//                     className="whatsapp-image"
//                   />
//                   <span className="text-[#fff]">WhatsApp</span>
//                 </div>
//               </button> */}
//             </span>
//             {/* <span
//               className="new-account"
//               onClick={() => props?.toggleSignUpPopup()}
//             >
//               New User? Create Account
//             </span>{" "} */}
//             {/* Added onClick event */}
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Login;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import { IoMdClose } from "react-icons/io";
import { FaMobileAlt, FaCaretDown, FaUser, FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import apiBaseUrl from "../../config/config";
import { useAuth } from "../AuthContext";
import { TbRefresh } from "react-icons/tb";

const Login = (props) => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [formData, setFormData] = useState({
    user_name: "",
    password: "",
    site_code: apiBaseUrl.sitecodes,
    user_type: "User",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [inputType, setInputType] = useState("mobile");
  const [isDisabled, setIsDisabled] = useState(false);
  const [captchaQuestion, setCaptchaQuestion] = useState("");
  const [captchaAnswer, setCaptchaAnswer] = useState("");

  // Generate CAPTCHA question
  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    setCaptchaQuestion(`${num1} + ${num2} = ?`);
    setCaptchaAnswer("");
  };

  // Initialize CAPTCHA on component mount
  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleInputTypeChange = (type) => {
    setInputType(type);
    setDropdownOpen(false);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const verifyCaptcha = () => {
    const parts = captchaQuestion.split(' ');
    const num1 = parseInt(parts[0]);
    const num2 = parseInt(parts[2]);
    return parseInt(captchaAnswer) === num1 + num2;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!verifyCaptcha()) {
      toast.error("CAPTCHA verification failed", { autoClose: 800 });
      generateCaptcha();
      return;
    }

    var config = {
      method: "post",
      url: `${apiBaseUrl.apiUrl}users/userAuthenticate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify(formData),
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          toast.success(response.data.resultMessage, { autoClose: 500 });
          login(response.data.resultData);
          setTimeout(() => {
            props?.togglePopup();
            props?.handleClose();
          }, 1000);
        } else {
          toast.error("Invalid Credentials", { autoClose: 800 });
        }
        setFormData({
          user_name: "",
          password: "",
          site_code: apiBaseUrl.sitecodes,
          user_type: "User",
        });
        generateCaptcha();
      })
      .catch(function (error) {
        console.log(error);
        toast.error("An error occurred during login", { autoClose: 800 });
        generateCaptcha();
      });
  };

  const loginDemoID = async () => {
    // if (!verifyCaptcha()) {
    //   toast.error("CAPTCHA verification failed", { autoClose: 800 });
    //   generateCaptcha();
    //   return;
    // }

    setIsDisabled(true);
    var demoData = {
      user_name: "demo_user",
      password: "Abcd1234",
      site_code: apiBaseUrl.sitecodes,
      user_type: "User",
    };

    var config = {
      method: "post",
      url: `${apiBaseUrl.apiUrl}users/userAuthenticate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify(demoData),
    };

    axios(config)
      .then(function (response) {
        setIsDisabled(false);
        if (response.data.result != 0) {
          // toast.success('logged innnnn..', { autoClose: 500 });
          props?.handleClose();
          toast.success(response.data.resultMessage, { autoClose: 500 });
          login(response.data.resultData);
          if (props?.togglePopup) props.togglePopup();
          if (props?.handleClose) props.handleClose();
          // generateCaptcha();
        } else {

          toast.success(response.data.resultMessage, { autoClose: 800 });
          props?.handleClose();
          // generateCaptcha();
        }
      })
      .catch(function (error) {
        setIsDisabled(false);
        console.log(error);
        // generateCaptcha();
      });
  };

  return (
    <>
      {props?.showPopup && (
        <div
          className="login-popup-overlay fixed inset-0  bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-50"
          onClick={() => props?.togglePopup()}
        >
          <div
            className=" login-popup-content w-[355px]"
            onClick={(e) => e.stopPropagation()}
          >
            <span
              className="absolute top-2 right-2 p-1 text-black hover:text-gray-800 cursor-pointer transition-colors"
              onClick={() => props?.togglePopup()}
            >
              <IoMdClose className="w-5 h-5" />
            </span>

            <div className="login-popup-logo ">
              <h5 className="text-black text-center font-bold text-[20px] mt-2">
                Login
              </h5>
            </div>

            <form className="login-form text-[#000]" onSubmit={handleSubmit}>
              <label className="text-black text-sm mb-1 w-[281px] ml-5">
                {inputType === "mobile" ? "Mobile Number" : "User ID"}
              </label>

              <div className="relative mb-3">
                {/* Input Box */}
                <div className="flex items-center border border-gray-300 rounded-lg h-[43px] w-[281px] ml-5 relative">
                  {/* Prefix Label */}
                  <div className="pl-3 pr-2 text-black whitespace-nowrap">
                    {inputType === "mobile" ? "+91" : "ID"}
                  </div>

                  {/* Input */}
                  <input
                    className="flex-1 py-2 pr-14 focus:outline-none border-none bg-transparent"
                    type="text"
                    name="user_name"
                    placeholder={
                      inputType === "mobile" ? "Enter mobile number" : "Enter user ID"
                    }
                    required
                    value={formData.user_name}
                    onChange={handleInputChange}
                  />

                  {/* Toggle Icons */}
                  <div
                    className="flex items-center space-x-1 absolute top-1/2 right-2 transform -translate-y-1/2 cursor-pointer"
                    onClick={toggleDropdown}
                  >
                    <FaMobileAlt size={20} color="#18adc5" />
                    <FaCaretDown size={16} color="#18adc5" />
                  </div>
                </div>

                {/* Dropdown */}
                {dropdownOpen && (
                  <div className="absolute mt-1 w-[281px] ml-5 bg-white border border-gray-300 rounded-lg shadow z-10">
                    <div
                      className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-100"
                      onClick={() => handleInputTypeChange("mobile")}
                    >
                      <FaMobileAlt size={18} color="#e9b02e" />
                      <span className="text-sm text-black">Mobile Number</span>
                    </div>
                    <div
                      className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-100"
                      onClick={() => handleInputTypeChange("userid")}
                    >
                      <FaUser size={18} color="#e9b02e" />
                      <span className="text-sm text-black">User ID</span>
                    </div>
                  </div>
                )}
              </div>

              {/* <span className="text-black w-[281px] ml-5">Password</span>
              <div className="password w-[281px] ml-5">

                <input
                  className="password-input w-[281px] ml-5"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Password"
                  required
                  value={formData.password}
                  onChange={handleInputChange}
                />
                <span
                  className="password-toggle"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
                </span>
              </div> */}
              <div className="relative mb-3">
                {/* Label */}
                <span className="text-black w-[281px] ml-5 block mb-1">Password</span>

                {/* Password Input Box */}
                <div className="flex items-center border border-gray-300 rounded-lg h-[43px] w-[281px] ml-5">
                  {/* Lock Icon */}


                  {/* Password Input */}
                  <input
                    className="flex-1 py-2 pr-10 focus:outline-none border-none bg-transparent"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password"
                    required
                    value={formData.password}
                    onChange={handleInputChange}
                  />

                  {/* Eye Toggle */}
                  <button
                    type="button"
                    className="px-3 text-gray-500 hover:text-gray-700 focus:outline-none"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
                  </button>
                </div>
              </div>

              {/* CAPTCHA Section */}
              <div className="mt-4 space-y-2 w-[281px] ml-5">
                {/* <label className="block text-sm font-medium text-gray-700">Captcha Verification</label> */}
                <div className="flex items-center gap-2">
                  {/* Captcha Question */}
                  <div className="flex-1 bg-gray-100 p-2 rounded-md text-center font-mono text-sm">
                    {captchaQuestion}
                  </div>

                  {/* Answer Input */}
                  <input
                    type="text"
                    placeholder="Enter answer"
                    value={captchaAnswer}
                    onChange={(e) => setCaptchaAnswer(e.target.value)}
                    className="flex-1 p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                    required
                  />

                  {/* Refresh Button */}
                  <button
                    type="button"
                    onClick={generateCaptcha}
                    className="p-2 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors"
                    aria-label="Refresh captcha"
                  >
                    <TbRefresh className="w-5 h-5" />
                  </button>
                </div>
              </div>

              <button
                type="submit"
                className="w-[281px] ml-5 flex items-center justify-center text-[16px] rounded-[3px] h-[40px] px-[10px] pt-[3px] pb-[5px] border border-[#065265] bg-gradient-to-b from-[#6fe3f5] to-[#065265] text-white shadow-sm transition-all duration-200"
                style={{ textShadow: "0 1px 1px rgba(0,0,0,0.5)", marginTop: 10, marginLeft: "17px" }}
              >
                <span className="front">Login</span>
              </button>

              <button
                type="button"
                onClick={loginDemoID}
                className="w-[281px] ml-5 flex items-center  justify-center text-[16px] rounded-[3px] h-[40px] px-[10px] pt-[3px] pb-[5px] border border-[#065265] bg-gradient-to-b from-[#6fe3f5] to-[#065265] text-white shadow-sm transition-all duration-200"
                style={{ textShadow: "0 1px 1px rgba(0,0,0,0.5)", marginTop: 10, }}
                disabled={isDisabled}
              >
                <span className="front">Login With Demo</span>
              </button>
            </form>
            <span className=""
              style={{
                color: "#000",
                display: "block",
                textAlign: "right",
                marginTop: "10px",
                marginRight: "18px",
              }}
              onClick={() => props.toggleForgotPopup()}
            >
              Forgot Password
            </span>
            <span className="other-login text-black">Or login with</span>
            <span className="other-button">
              {/* <button className="google border border-gray-500">
                <div className="flex justify-center items-center">
                  <img src="./Images/google.png" alt="" className="google-image" />
                  <span className="text-[#fff]">Google</span>
                </div>
              </button> */}
              <button className="whatsapp"
                onClick={() => props?.openWhatsApp(props?.whatsappNum)}
              >
                <div className="flex justify-center items-center">
                  <img
                    src="./Images/whatsapp.png"
                    alt=""
                    className="whatsapp-image"
                  />
                  <span className="text-[#fff]">WhatsApp</span>
                </div>
              </button>
            </span>
            <span className="new-account text-black" onClick={() => props.toggleSignUpPopup()}>
              New User? Create Account
            </span>
          </div>
        </div >
      )}
    </>
  );
};

export default Login;